import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'admin',
    pathMatch: 'full'
  },
  {
    path: 'admin',
    canMatch: [authGuard],
    canActivate: [authGuard, roleGuard],
    loadChildren: () =>
      import('./features/admin/admin.route')
        .then(r => r.ADMIN_ROUTES)
  },
  {
    path: '**',
    loadComponent: () => import('./features/not-found/not-found').then(m => m.NotFound)
  }
];
